<template>
	<div>
		<a-modal :title="getTitle" :width="480" :visible="visible" @cancel="handleCancel">
			<template slot="footer">
				<a-button key="back" @click="handleCancel">
					取消
				</a-button>
				<a-button key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					保存
				</a-button>
			</template>
			<a-spin :spinning="loading">
				<div>

					<div class="flex  mt24">
						<a-input class="" style="width: 230px;" placeholder="请输入角色名称" v-model="form.name" :maxLength="20">
						</a-input>
						<a-input-number class=" ml20" style="width: 230px;" placeholder="请输入排序号(越大越靠前)" v-model="form.sort"
							:precision="0" :min="0" />
					</div>

					<div class="flex  mt10">
						<a-input class="woyaou-input " prefix="角色描述" style="width: 480px;" placeholder="请输入角色描述" v-model="form.desc"
							:maxLength="100">
						</a-input>
					</div>

					<div class="mt24">
						<div>
							<a-switch v-model="includes" />
							<span class="ml10">是否含下级</span>
						</div>
						<a-tree v-model="virtualCheckedKeys" :tree-data="category" checkable checkStrictly
							:default-expand-all="true" :default-expanded-keys="expandedKeys" @check="onCheck" style="width: 100%">
						</a-tree>
					</div>

					<div class="flex  mt10" style="display: none;">
						<a-input class="woyaou-input " prefix="菜单" style="width: 480px;" placeholder="请选择菜单"
							v-model="selectedMenusText" :maxLength="100">
						</a-input>
					</div>

				</div>
			</a-spin>
		</a-modal>
	</div>
</template>

<script>
import uploadImg from '../../../../../components/upload/upload.vue';
import * as treeUtils from '../../../../../utils/tree';
export default {
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		role_id: {
			type: Number,
			default: 0,
		},
	},
	components: {
		uploadImg,
	},
	data() {
		return {
			loading: false,
			confirmLoading: false,
			category: [],
			menu_id: 0,
			pid: 0,
			role: [],
			includes: true,
			// 树形控件相关
			checkedKeys: [], // 用户实际选中的节点 key 值（叶子节点）
			expandedKeys: [], // 展开的节点 key 值
			virtualCheckedKeys: [], // 虚拟的选中 keys（包含需要显示勾选的父节点）
			selectedMenusText: '', // 选中的菜单ID文本（调试用）
			form: {
				name: '',
				desc: '',
				sort: '',
				menus: '',
			},

		}
	},
	computed: {
		getTitle() {
			if (this.role_id == 0) {
				return "添加角色";
			} else {
				return "编辑角色"
			}
		}
	},
	created() {
		this.loaddata();
	},
	watch: {
		// 监听 visible 变化，当弹窗显示时重新加载数据
		visible(newVal) {
			if (newVal) {
				this.loaddata();
			}
		}
	},
	methods: {

		loaddata() {
			if (this.loading == true) return;
			this.loading = true;
			// 菜单树
			this.$http.api('admin/getMenuTree', {
				menu_id: this.menu_id,
			}).then(res => {
				this.category = res.category;
				console.log('this.category.tree', res.category)

				// 生成所有节点的 key 用于默认展开所有节点
				this.expandedKeys = this.getAllNodeKeys(res.category);

				//this.loading=false;
				// 角色数据
				this.$http.api('admin/showSysrole', {
					role_id: this.role_id,
				}).then(res => {
					//this.role=res.role;
					if (res.detail) {
						console.log('res.detail', res.detail)
						this.form = res.detail;

						// 如果有已选择的菜单，设置到 checkedKeys
						if (res.detail.menus) {
							// 【修改】这里需要解析虚拟选中的节点（包含父节点）
							this.virtualCheckedKeys = res.detail.menus.split(',').map(id => Number(id));
							this.checkedKeys = res.detail.menus.split(',').map(id => Number(id));

							// 【新增】从虚拟选中节点中提取实际的叶子节点
							// this.checkedKeys = this.extractActualCheckedKeys(this.virtualCheckedKeys);
						}
					}
					this.loading = false;
				}).catch(res => {
					console.log(res);
					this.loading = false;
				})

			}).catch(res => {
				console.log(res);
				//this.loading=false;
			})


		},

		/**
		 * 递归获取所有节点的 key
		 */
		getAllNodeKeys(treeData) {
			let keys = [];
			const traverse = (nodes) => {
				nodes.forEach(node => {
					keys.push(node.key || node.menu_id); // 根据实际数据结构调整 key 字段名
					if (node.children && node.children.length > 0) {
						traverse(node.children);
					}
				});
			};
			traverse(treeData);
			return keys;
		},
		/**
		 * 【修改】树节点勾选事件 - 新的联动逻辑
		 */
		onCheck(checkedKeys, e) {
			const checkedList = checkedKeys.checked;
			const { checked, node } = e;
			let nodeList = [node._props.dataRef];
			// 获取当前节点的子节点
			let keyAndChildKeys = treeUtils.treeToList(nodeList).map(item => item.key);

			if (checked) {
				if (this.includes) {
					this.checkedKeys = [...new Set([...keyAndChildKeys, ...this.checkedKeys])];
				} else {
					this.checkedKeys = [...checkedList];
				}
			} else {
				if (this.includes) {
					this.checkedKeys = this.checkedKeys.filter(v => !keyAndChildKeys.includes(v));
				} else {
					this.checkedKeys = checkedList;
				}
			}
			this.virtualCheckedKeys = this.checkedKeys;
		},
		/**
		 * 取消弹窗
		 */
		handleCancel() {
			this.$emit("cancel");
		},

		/**
		 * 提交数据
		 */
		onSubmit() {
			if (this.confirmLoading == true) return;
			this.confirmLoading = true;

			// 确保 menus 是最新的选中值
			this.form.menus = this.checkedKeys.join(',');

			console.log('提交的数据:', {
				role_id: this.role_id,
				name: this.form.name,
				desc: this.form.desc,
				sort: this.form.sort,
				menus: this.form.menus, // 逗号拼接的菜单ID
			});

			this.$http.api('admin/saveSysrole', {
				role_id: this.role_id,
				name: this.form.name,
				desc: this.form.desc,
				sort: this.form.sort,
				menus: this.form.menus,
			}).then(res => {
				this.$message.success('保存成功', 1, () => {
					this.confirmLoading = false;
					this.$emit("ok");
				})

			}).catch(res => {
				console.log(res);
				this.confirmLoading = false;
			})

		},

	}
}
</script>

<style></style>
